/* eslint-disable react/jsx-props-no-spreading */

import { observer } from 'mobx-react-lite';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import {
  Button,
  ErrorBoundary,
  ErrorBox,
  LinkButton,
  LoadingContainer,
  Page,
} from '../components';
import Layout from '../components/layout';
import { useStore } from '../store';
import getAllRoutes, { Route as RouteModel } from './routes';

export default observer(function RootRoutes() {
  const routes = getAllRoutes();
  const { authStore } = useStore();

  return (
    <BrowserRouter>
      <Routes>
        {routes.map((route) => (
          <Route
            element={<RouteWrapper route={route} />}
            key={route.route}
            path={`${route.route}/*`}
          />
        ))}
        <Route
          element={
            <Navigate to={authStore.isLoggedIn ? '/products' : '/login'} />
          }
          index
        />
        <Route
          element={
            <Layout>
              <Page>Not found</Page>
            </Layout>
          }
          path="*"
        />
      </Routes>
    </BrowserRouter>
  );
});

const RouteWrapper = observer(function RouteWrapper({
  route,
  ...rest
}: {
  route: RouteModel;
}) {
  const { authStore } = useStore();

  if (authStore.isRestoring) {
    return <LoadingContainer />;
  }

  if (route.minRole && !authStore.userHasRole(route.minRole)) {
    if (authStore.isLoggedIn) {
      return (
        <ErrorBox p={3}>
          You have no grants to view the page
          <p>
            <LinkButton icon="home" size="small" to="/" type="primary">
              Return to home page
            </LinkButton>

            <Button
              icon="sign-out-alt"
              onClick={authStore.signOut}
              size="small"
              sx={{ ml: 1 }}
              type="normal"
            >
              Sign out
            </Button>
          </p>
          <p />
        </ErrorBox>
      );
    }

    return <Navigate to="/login" />;
  }

  if (route.authRoute && authStore.isLoggedIn) {
    return <Navigate to="/" />;
  }

  const Component = route.component;
  const component = (
    <ErrorBoundary>
      <Component {...rest} />
    </ErrorBoundary>
  );

  if (route.noLayout) {
    return component;
  }

  return <Layout>{component}</Layout>;
});
